import {GameJackpotSiBox} from "./game-jackpot.si.box";

export const GameJackpotSiCisBox = GameJackpotSiBox